import { List, useTable } from "@refinedev/antd";
import { BaseKey, useDeleteMany, useTranslate } from "@refinedev/core";
import { Button, Popconfirm, Spin, Table } from "antd";
import React, { PropsWithChildren, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../contexts/ContextProvider";
import { numberToCurrency } from "../../../utility";

const ProductItemList: React.FC<PropsWithChildren> = ({ children }) => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

  const navigate = useNavigate();
  const translate = useTranslate();

  const { currentTeam } = useUser();

  const { tableProps, tableQueryResult } = useTable({
    resource: "product_items",
    meta: {
      select: "*",
    },
    sorters: {
      initial: [
        {
          field: "id",
          order: "desc",
        },
      ],
    },
    syncWithLocation: true,
    filters: {
      permanent: [
        {
          field: "account",
          value:
            currentTeam?.account_id ?? "00000000-0000-0000-0000-000000000000",
          operator: "eq",
        },
      ],
    },
  });

  const { mutate } = useDeleteMany();

  const handleDeleteBulk = () => {
    mutate({
      resource: "product_items",
      ids: selectedRowKeys as BaseKey[],
    });
    setSelectedRowKeys([]);
  };

  useEffect(() => {
    setSelectedRowKeys([]);
  }, [tableQueryResult.data?.data]);
  const handleRowClick = (event: any, id: any) => {
    if (event.target.className !== "ant-checkbox-input") navigate("show/" + id);
  };

  if (!currentTeam || !currentTeam?.account_id || tableProps.loading) {
    return <Spin />;
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  return (
    <>
      <List
        title={translate("product_items.list.title")}
        breadcrumb={false}
        headerButtons={({ defaultButtons }) => (
          <>
            {selectedRowKeys.length != 0 && (
              <Popconfirm
                title={translate("product_items.buttons.delete.title")}
                description={translate(
                  "product_items.buttons.delete.description"
                )}
                onConfirm={handleDeleteBulk}
                okText={translate("buttons.yes", "Yes")}
                cancelText={translate("buttons.no", "No")}
              >
                <Button type="primary" danger>
                  {translate("product_items.buttons.delete.selected")}
                </Button>
              </Popconfirm>
            )}
            {defaultButtons}
          </>
        )}
      >
        <Table
          {...tableProps}
          rowKey={(record) => record.id ?? ""}
          rowClassName={"clickableRow"}
          loading={currentTeam === undefined}
          onRow={(record) => {
            return {
              onClick: (event) => handleRowClick(event, record.id),
            };
          }}
          pagination={{
            ...tableProps.pagination,
            showSizeChanger: true,
          }}
          rowSelection={rowSelection}
        >
          <Table.Column
            dataIndex="title"
            title={translate("product_items.fields.title")}
          />
          {/*<Table.Column*/}
          {/*  dataIndex="description"*/}
          {/*  render={(text) => (*/}
          {/*    <>{text?.length > 50 ? text.substring(0, 50) + "..." : text}</>*/}
          {/*  )}*/}
          {/*  title={translate("product_items.fields.description")}*/}
          {/*/>*/}
          <Table.Column
            dataIndex="netto_price"
            render={(text, record: any) => (
              <div>
                {numberToCurrency(text, record?.currency.toLowerCase())}
              </div>
            )}
            title={translate("product_items.fields.netto_price")}
          />
          <Table.Column
            dataIndex="sales_tax"
            render={(text) => <>{text}%</>}
            title={translate("product_items.fields.sales_tax")}
          />
          <Table.Column
            dataIndex="billing_interval"
            render={(text, record: any) => (
              <>
                {record?.invoice_interval},{" "}
                {translate(
                  `product_items.fields.billing_interval_enum.${text}`
                )}
              </>
            )}
            title={translate("product_items.fields.billing_interval")}
          />
          <Table.Column
            dataIndex="created_at"
            title={translate("product_items.fields.created_at")}
            sorter={true}
            render={(val) => {
              return (
                <>
                  {val
                    ? new Date(val).toLocaleString(
                        translate("pipelines.date_locale")
                      )
                    : null}
                </>
              );
            }}
          />
        </Table>
      </List>
      {children}
    </>
  );
};
export default ProductItemList;
